<template>
    <div>
        <div v-if="typeof(value) == 'object' && value != null" class="row">
            <template v-for="(v, n) in value">
                <template v-if="typeof(v) == 'object' && v != null">
                    <div class="col-12"></div>
                    <b-col :md="12">
                        <b-form-group :label="n"
                                      :label-cols="12"
                                      :title="n"
                                      :horizontal="true"
                                      label-align="left">
                            <hr />
                            <json-field :value="v" :name="n" :gridColumn="gridColumn" :labelColumn="labelColumn"></json-field>
                        </b-form-group>
                    </b-col>
                </template>
                <template v-else>
                    <b-col :md="gridColumn">
                        <b-form-group :label="n"
                                      :label-cols="labelColumn"
                                      :title="n"
                                      :horizontal="true"
                                      label-align="left">
                            <json-field :value="v" :name="n" :gridColumn="gridColumn" :labelColumn="labelColumn"></json-field>
                        </b-form-group>
                    </b-col>
                </template>
            </template>
        </div>
        <div v-else>
            <template v-if="typeof(value) == 'boolean'">
                <b-form-checkbox v-model="field.value" disabled="disabled"></b-form-checkbox>
            </template>
            <template v-else>
                <input-auto-size :value="value" :title="name" v-if="name"></input-auto-size>
            </template>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'JsonField',
        props: {
            value: {
                required: true
            },
            name: {
                required: false
            },
            gridColumn: {
                default: 6
            },
            labelColumn: {
                default: 3
            }
        },
        data() {
            return {
            }
        },
        mounted: function () {

        }
    }
</script>

<style scoped>
</style>

